import React, { FC, memo } from 'react';
import SettingsLogo from '@components/logos/SettingsLogo';
// import HouseLogo from '@components/logos/HouseLogo';
import ProgramsLogo from '@components/logos/ProgramsLogo';
import AvatarLogo from '@components/logos/AvatarLogo';
import FireLogo from '@components/logos/FireLogo';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Field } from '@/types';
import { MailLogo } from './logos/MailLogo';
import { LocationLogo } from './logos/LocationLogo';
import { PVLogo } from './logos/PVLogo';
import { EnergyProfLogo } from './logos/EnergyProfLogo';
import { AnnualConsLogo } from './logos/AnnualConsLogo';
import { HeatSupplyLogo } from './logos/HeatSupplyLogo';
import { ChargingStatLogo } from './logos/ChargingStatLogo';
import { BuildingLogo } from './logos/BuildingLogo';

const LOGOS = {
  'Wohin dürfen wir Ihre Ergebnisse senden?': <MailLogo width="40" height="40" />,
  Adresse: <LocationLogo width="40" height="40" />,
  'PV-Fläche': <PVLogo width="40" height="40" />,
  'Jährlicher Verbrauch': <AnnualConsLogo width="40" height="40" />,
  Energieprofil: <EnergyProfLogo width="40" height="40" />,
  'Ort der Anlage': <MailLogo />,
  Bestandsanlage: <SettingsLogo />,
  Stromverbrauch: <SettingsLogo />,
  'Verfügbare Fläche': <ProgramsLogo />,
  Kundendaten: <AvatarLogo />,
  Wärmeversorgung: <HeatSupplyLogo width="40" height="40" />,
  Ladesäulen: <ChargingStatLogo width="40" height="40" />,
  Gebäudenutzfläche: <BuildingLogo width="40" height="40" />,
};

const CATEGORIES_WITH_TOOLTIP = ['Wärmeversorgung'];

interface Props {
  category: string;
  qns?: Field[];
  name: string;
}

const CategoryTitle: FC<Props> = ({ category, name, qns }) => {
  const description = qns?.find(f => f.category === category)?.description;

  return (
    <div className={`mt-[190px] md:mt-12 pt-6`}>
      <div>{LOGOS[category as keyof typeof LOGOS] || <SettingsLogo />}</div>
      <div className=" flex flex-row items-center gap-2">
        <h2 className="font-bold text-[24px] md:text-[36px] text-header" style={{ color: 'var(--header)' }}>
          {category || name}
        </h2>
        {CATEGORIES_WITH_TOOLTIP.includes(category) && description && (
          <span className="tooltip tooltip-right" data-tip={description}>
            <InformationCircleIcon className="icon-color" />
          </span>
        )}
      </div>
    </div>
  );
};

export default memo(CategoryTitle);
